import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";
import { queryClient } from "../../../shared/providers/QueryProvider";

export const useStageGate = (projectId: string | undefined) => {

    const { data, isFetching, isPending, isLoading, isError, refetch } = useQuery({
        queryKey: ["project-stage-gates", projectId],
        queryFn: () => projectDetailsApi.fetchProjectStageGates(projectId),
        enabled: !!projectId,
    });

    return {
        stageGateData: data?.data,
        isPending: isPending || isFetching || isLoading, isFetching, isError,
        refetch,
        removeCache: () => {
            queryClient.removeQueries({ queryKey: ["project-stage-gates", projectId] });
        }
    }

};